// extracted by mini-css-extract-plugin
export default {"map":"Progressmap_map__GsHAd"};